export const phonePlaceHoldersHash = {
  phone: '(___) ___-__-__',
  mobilePhone: '(9__) ___-__-__',
};
